import {exists} from '@eitje/utils'

export const calculateDeltaPercentage = ({actual, comparison}) => {
	// Actual can be missing in API data; comparison is missing for points without a previous or comparison value.
	if (!exists(actual) || !exists(comparison)) return null
	if (comparison === 0) return actual === 0 ? 0 : null

	return ((actual - comparison) / comparison) * 100
}
